import { BackgroundSignStyle } from "./styles"

export default function BackgroundSign() {
  return (
    <BackgroundSignStyle>
      <div className="bg-black">
        <div className="div-card">
        </div>
      </div>
    </BackgroundSignStyle>
  )
}